export const LOAD_USER = 'customers/LOAD_USER';